import React from 'react';
import { Repeat2 } from 'lucide-react';
import { AudioEffect, AudioEffectControlProps } from './AudioEffect';
import { AudioSourceRegistry } from '../../../../dataTypes/liveStreamManagment/audioPipeline/AudioSourceRegistry';
import { LevelSlider } from '../LevelSlider';

export interface EchoConfig {
  /** Temps avant la première répétition, en ms. */
  delayMs: number;
  /** Proportion réinjectée à chaque répétition, 0-0.8 — plafonné côté registry. */
  feedback: number;
  /** Proportion de signal retardé mélangée au signal sec, 0-1. */
  mix: number;
}

class EchoEffectImpl extends AudioEffect<EchoConfig> {
  readonly id = 'echo';
  readonly label = 'Echo';
  readonly icon = Repeat2;
  readonly description = 'Répétitions retardées de la voix, avec réinjection progressive';
  readonly defaultConfig: EchoConfig = { delayMs: 300, feedback: 0.35, mix: 0.3 };

  apply(registry: AudioSourceRegistry, regId: string, enabled: boolean, config: EchoConfig): void {
    registry.setEchoDelay(regId, enabled, config.delayMs, config.feedback, config.mix);
  }

  renderControls({ config, onChange }: AudioEffectControlProps<EchoConfig>) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <LevelSlider
          label="Délai" value={config.delayMs}
          min={50} max={1000} defaultValue={300} roundTo={10}
          format={v => `${v} ms`}
          onChange={delayMs => onChange({ ...config, delayMs })}
        />
        <LevelSlider
          label="Répétitions" value={config.feedback}
          min={0} max={0.8} defaultValue={0.35} roundTo={0.05}
          format={v => `${Math.round(v * 100)}%`}
          onChange={feedback => onChange({ ...config, feedback })}
        />
        <LevelSlider
          label="Mix" value={config.mix}
          min={0} max={1} defaultValue={0.3} roundTo={0.05}
          format={v => `${Math.round(v * 100)}%`}
          onChange={mix => onChange({ ...config, mix })}
        />
      </div>
    );
  }
}

export const echoEffect = new EchoEffectImpl();
